var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse83(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 83",
    cx: 19.0986,
    cy: 18.4502,
    r: 17.337,
    fill: "#3E1A0D",
    stroke: "#181818",
    strokeWidth: 2.10145
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse83);
export default __webpack_public_path__ + "static/media/Ellipse-83.da880bf96a2dc73922f901e7fd8d4276.svg";
export { ForwardRef as ReactComponent };